<div class="row modal-bar">
  <div class="col-sm-6">
    <h5 class="modal-title">{{ passedData.title | translate }}</h5>
  </div>
  <div class="col-sm-6">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>

<form [formGroup]="form" class="form-content">
  <div class="section-wrapper">
    <div class="form-layout">
      <div class="row mg-b-25">
        <div class="col-lg-6">
          <div class="form-group">
            <label class="form-control-label">{{ 'DIALOGS.EDIT-REFERENCE-DATE.FORM.LABEL.SEASON' | translate }}<span class="tx-danger">*</span></label>
            <ng-select [items]="seasons" bindLabel="Name" bindValue="Id" 
                       placeholder="{{ 'DIALOGS.EDIT-REFERENCE-DATE.FORM.PLACEHOLDER.SEASON' | translate }}" 
                       formControlName="SeasonId"
                       [clearable]="false" 
                       notFoundText="{{ 'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate }}" 
                       appendTo="body">
              <ng-template ng-label-tmp ng-option-tmp let-item="item">
                {{ item.Name }}
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label class="form-control-label">{{ 'DIALOGS.EDIT-REFERENCE-DATE.FORM.LABEL.DATE' | translate }}<span class="tx-danger">*</span></label>
            <input type="text" class="form-control" datepicker formControlName="Date" autocomplete="off">
          </div>
        </div>
      </div>

      <div class="row mg-b-25">
        <div class="col-lg-12">
          <div class="form-group">
            <label class="form-control-label">{{ 'DIALOGS.EDIT-REFERENCE-DATE.FORM.LABEL.BEFORE_AFTER' | translate }}<span class="tx-danger">*</span></label>
            <div class="d-flex">
              <div class="form-check me-4">
                <input class="form-check-input" type="radio" formControlName="BeforeAfter" value="B" id="beforeRadio">
                <label class="form-check-label" for="beforeRadio">{{ 'DIALOGS.EDIT-PRICE-VARIATION.FORM.TABLE.BEFORE' | translate }}</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" formControlName="BeforeAfter" value="A" id="afterRadio">
                <label class="form-check-label" for="afterRadio">{{ 'DIALOGS.EDIT-PRICE-VARIATION.FORM.TABLE.AFTER' | translate }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-layout-footer row">
        <div class="col-6">
          <button (click)="submit()" [disabled]="form.invalid" class="btn btn-block btn-primary bd-0">
            <i class="far fa-save"></i><span>{{ 'BTN.SAVE' | translate }}</span>
          </button>
        </div>
        <div class="col-6">
          <button (click)="dialogRef.close(false);" class="btn btn-block btn-secondary bd-0">
            <i class="fas fa-ban"></i><span>{{ 'BTN.CANCEL' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
